import React, {useContext, forwardRef, useImperativeHandle, useRef} from 'react';
import {LangCtx} from "../../context";
import {addrLangObj} from "../../../locale/address/index";
// For CSS
import './Dropdown.css';


const AddrDropDown = forwardRef((props, ref) => {
    const {l} = useContext(LangCtx);
    const al = addrLangObj[l.locale];
    const inputRef = useRef(ref);

    useImperativeHandle(ref, () => ({
        focus: () => {
            inputRef.current.focus();
        }
    }));

    return (
        <div className={`selectInput ${props.size} ${props.disabled ? "disabledStripeInput" : ""}`}>
            <select onChange={props.onChange} value={props.value} name={props.name} ref={inputRef} disabled={props.disabled}>
            {props.placeholder && (
                    <option value="" disabled >
                        {props.placeholder}
                    </option>
                )}
                {props.items && props.items.length > 0 && props.items.map((item) => <option value={item.value} key={item.value}>{item.label ? item.label : item.defaultlabel ? l[item.defaultlabel] : al[item.value]}</option>)}
            </select>
            <label>{props.labelText}</label>
            {props.error && <span className="selectErrorMsg">{props.errorMsg}</span>}
        </div>
    )
})
export default AddrDropDown;

